import React from "react";
import {useHistory} from "react-router";
import {Button, Table} from "antd";


const columns = [
    {
        title: '序号',
        dataIndex: 'code',
        render: text => <span>{text}</span>,
    },
    {
        title: '采购订单号',
        dataIndex: 'name',
        align: 'left',
    },
    {
        title: '运输通知单号',
        dataIndex: 'date',
    },
    {
        title: '订单类型',
        dataIndex: 'unOutCount',
    },
    {
        title: '状态',
        dataIndex: 'status',
    },
    {
        title: '是否已打印',
        dataIndex: 'status',
    },
    {
        title: '打印次数',
        dataIndex: 'status',
    },
    {
        title: '最后打印人',
        dataIndex: 'status',
    },
    {
        title: '发运方式',
        dataIndex: 'status',
    },
    {
        title: '到站',
        dataIndex: 'status',
    },
    {
        title: '通讯地址',
        dataIndex: 'status',
    },
    {
        title: '收货单位',
        dataIndex: 'status',
    },
    {
        title: '联系人',
        dataIndex: 'status',
    },
    {
        title: '联系人手机',
        dataIndex: 'status',
    },
    {
        title: '联系人电话',
        dataIndex: 'status',
    },
    {
        title: '订单份数',
        dataIndex: 'status',
    },
    {
        title: '清单份数',
        dataIndex: 'status',
    },
    {
        title: '总重量',
        dataIndex: 'status',
    },
    {
        title: '运费承担方',
        dataIndex: 'status',
    },
    {
        title: '物流状态',
        dataIndex: 'status',
    },
    {
        title: '备注',
        dataIndex: 'status',
    }
];
const data = [
    {
        key: '1',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '2',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '3',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '4',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '5',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '6',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
];
export default function () {
    const history = useHistory();
    const onAdd = () => {
        history.push({pathname: "/purchase/invoice/detail", state: {id: "2-2-1"}})
    }
    const onEdit = () => {

    }
    const onImport = () => {

    }
    const onExport = () => {

    }
    const onDownloadTpl = () => {

    }
    return (
        <>
            <div style={{margin: "12px 0"}}>
                <Button className="margin-left-8" onClick={onExport}>导出</Button>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                bordered
                pagination={true}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled User',
                        name: record.name,
                    }),
                }}
                scroll={{x: 'max-content'}}
            />
        </>
    );
}